import { z } from 'zod';

/**
 * Reference data. Created online only, from the office posture — which is what lets the
 * serial numbers stay tidy and server-assigned instead of needing client-side UUIDs.
 */

export const CartStatus = z.enum(['active', 'decommissioned', 'lost']);
export type CartStatus = z.infer<typeof CartStatus>;

export const SiteStatus = z.enum(['active', 'archived']);
export type SiteStatus = z.infer<typeof SiteStatus>;

export const Site = z.object({
  code: z.string().regex(/^SITE-\d{6}$/),
  name: z.string().min(1).max(120),
  status: SiteStatus,
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export type Site = z.infer<typeof Site>;

export const Cart = z.object({
  code: z.string().regex(/^CHT-\d{6}$/),
  name: z.string().min(1).max(120),
  status: CartStatus,
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export type Cart = z.infer<typeof Cart>;

export const CreateSite = z.object({ name: z.string().min(1).max(120) });
export const CreateCart = z.object({ name: z.string().min(1).max(120) });
export const UpdateSite = z.object({
  name: z.string().min(1).max(120).optional(),
  status: SiteStatus.optional(),
});
export const UpdateCart = z.object({
  name: z.string().min(1).max(120).optional(),
  status: CartStatus.optional(),
});

/** Bulk creation — 200 carts is realistically seeded in one go, not one at a time. */
export const CreateCartsBulk = z.object({
  count: z.number().int().min(1).max(500),
  name_prefix: z.string().min(1).max(60).default('Chariot'),
  /** First serial to use for the generated names; codes are always sequential. */
  start_number: z.number().int().min(1).optional(),
});
